import { c as _c } from "react/compiler-runtime";
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { tableOfContentsMap } from './constants';
export const useTableOfContents = () => {
  const $ = _c(14);
  const {
    benefitsAndPerks,
    bottomLine,
    consBullets,
    comparisonTable,
    detailedReview,
    drawbacksAndConsiderations,
    howToDecide,
    marketplaceEntity,
    prosBullets
  } = useReviewContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Object.values(tableOfContentsMap);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== benefitsAndPerks || $[2] !== bottomLine || $[3] !== comparisonTable || $[4] !== consBullets || $[5] !== detailedReview || $[6] !== drawbacksAndConsiderations || $[7] !== howToDecide || $[8] !== marketplaceEntity || $[9] !== prosBullets) {
    t1 = t0.filter(section => {
      const visibleSectionsMapper = {
        "the-bottom-line": !!bottomLine || !!marketplaceEntity.starRating,
        "benefits-and-perks": !!benefitsAndPerks,
        "detailed-review": !!detailedReview,
        "drawbacks-and-considerations": !!drawbacksAndConsiderations,
        "compare-to-other-cards": !!comparisonTable && (comparisonTable.columns || []).length > 1,
        "how-to-decide-if-its-right-for-you": !!howToDecide,
        "pros-and-cons": prosBullets.length > 0 || consBullets.length > 0
      };
      return section.id in visibleSectionsMapper ? visibleSectionsMapper[section.id] : true;
    });
    $[1] = benefitsAndPerks;
    $[2] = bottomLine;
    $[3] = comparisonTable;
    $[4] = consBullets;
    $[5] = detailedReview;
    $[6] = drawbacksAndConsiderations;
    $[7] = howToDecide;
    $[8] = marketplaceEntity;
    $[9] = prosBullets;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  const visibleSections = t1;
  const shouldDisplay = !!detailedReview && visibleSections.length > 2;
  let t2;
  if ($[11] !== shouldDisplay || $[12] !== visibleSections) {
    t2 = {
      visibleSections,
      shouldDisplay
    };
    $[11] = shouldDisplay;
    $[12] = visibleSections;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};